module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-dis-8942d01af6affdacc631e7d1fe08b7c4.png";